import { useEffect } from "react";
import "./Footer.css";

function Footer() {
    useEffect(() => {
        const script = document.createElement("script");
        script.src = "https://cdn.iubenda.com/iubenda.js";
        script.async = true;
        document.body.appendChild(script);
    }, []);





    return (
        <footer>
            <div className="footerContenitor">
                <a href="/" className="logo">
                    <img src="/Assets/navLogo.svg" alt="Logo Positanonboard" />
                </a>
            </div>

            <hr />

            <div className="footerCopyright">
                <div className="Cookies" id="Cookies">
                    <ul>
                        <li>
                            <a
                                href="https://www.iubenda.com/privacy-policy/83599743"
                                className="iubenda-black iubenda-noiframe iubenda-embed"
                                title="Privacy Policy"
                                aria-label="Leggi la nostra Privacy Policy su Iubenda"
                                hreflang="it"
                            >
                                Privacy Policy
                            </a>
                        </li>
                        <li>
                            <a
                                href="https://www.iubenda.com/privacy-policy/83599743/cookie-policy"
                                className="iubenda-black iubenda-noiframe iubenda-embed"
                                title="Cookie Policy"
                                aria-label="Leggi la nostra Cookie Policy su Iubenda"
                                hreflang="it"
                            >
                                Cookie Policy
                            </a>
                        </li>
                    </ul>
                </div>

                <div className="copyright">
                    <span>
                        &copy; 2023 Positanonboard. All rights reserved. <br />
                        P.IVA: 06168110655
                    </span>
                </div>
            </div>
        </footer>

    );
}

export default Footer;
